import { MdtPurchaseWindow } from '@clipr/lib';

export const AGENCY_SIGNUP_DRAFT_KEY = 'agencySignupDraft';

export type AgencyOfficerFormRow = {
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  supervisorTitle: string;
  supervisorName: string;
  supervisorEmail: string;
};

export type AgencySignupFormModel = {
  sponsorFirstName: string;
  sponsorLastName: string;
  sponsorTitle: string;
  sponsorEmail: string;
  sponsorPhone: string;
  sponsorPassword: string;
  agencyName: string;
  swornOfficersCount: string;
  officers: AgencyOfficerFormRow[];
  reseller: string;
  resellerPocName: string;
  resellerPocEmail: string;
  mdtPurchaseWindow: MdtPurchaseWindow;
  mdtManufacturer: string;
  mdtModel: string;
  bwcPlatform: string;
  rmsPlatform: string;
  acceptedTerms: boolean;
};

export type AgencyRosterLimits = {
  pilotRows: number;
};

export const MAX_PILOT_OFFICERS = 50;

export const mdtPurchaseWindowOptions = [
  { value: MdtPurchaseWindow.Last_3Months, label: 'Last 3 months' },
  { value: MdtPurchaseWindow.Next_3Months, label: 'Next 3 months' },
  { value: MdtPurchaseWindow.NotSure, label: 'Not sure' },
];

export const resellerOptions = [
  { value: '', label: 'Select reseller...' },
  { value: 'TD SYNNEX', label: 'TD SYNNEX' },
  { value: 'CDW', label: 'CDW' },
  { value: 'SHI', label: 'SHI' },
  { value: 'Presidio', label: 'Presidio' },
  { value: 'Other', label: 'Other' },
];

export const mdtManufacturerOptions = [
  { value: '', label: 'Select manufacturer...' },
  { value: 'Getac', label: 'Getac' },
  { value: 'Lenovo', label: 'Lenovo' },
  { value: 'Panasonic', label: 'Panasonic' },
  { value: 'Dell', label: 'Dell' },
  { value: 'HP', label: 'HP' },
  { value: 'Other', label: 'Other' },
];

export const bwcPlatformOptions = [
  { value: '', label: 'Select platform...' },
  { value: 'Axon', label: 'Axon' },
  { value: 'Motorola', label: 'Motorola' },
  { value: 'Utility', label: 'Utility' },
  { value: 'Panasonic', label: 'Panasonic' },
  { value: 'Getac', label: 'Getac' },
  { value: 'Other', label: 'Other' },
];

export const rmsPlatformOptions = [
  { value: '', label: 'Select RMS...' },
  { value: 'Mark43', label: 'Mark43' },
  { value: 'Tyler', label: 'Tyler Technologies' },
  { value: 'Axon Records', label: 'Axon Records' },
  { value: 'Motorola PremierOne', label: 'Motorola PremierOne' },
  { value: 'CentralSquare', label: 'CentralSquare' },
  { value: 'Other', label: 'Other' },
];

export function createEmptyOfficerRow(): AgencyOfficerFormRow {
  return {
    firstName: '',
    lastName: '',
    title: '',
    email: '',
    supervisorTitle: '',
    supervisorName: '',
    supervisorEmail: '',
  };
}

export function createAgencySignupFormModel(): AgencySignupFormModel {
  return {
    sponsorFirstName: '',
    sponsorLastName: '',
    sponsorTitle: '',
    sponsorEmail: '',
    sponsorPhone: '',
    sponsorPassword: '',
    agencyName: '',
    swornOfficersCount: '',
    officers: [],
    reseller: '',
    resellerPocName: '',
    resellerPocEmail: '',
    mdtPurchaseWindow: MdtPurchaseWindow.NotSure,
    mdtManufacturer: '',
    mdtModel: '',
    bwcPlatform: '',
    rmsPlatform: '',
    acceptedTerms: false,
  };
}

export function getRosterLimits(swornOfficersCount: number): AgencyRosterLimits {
  return {
    pilotRows: swornOfficersCount > 0 ? Math.min(swornOfficersCount, MAX_PILOT_OFFICERS) : 0,
  };
}

export function isOfficerRowComplete(row: AgencyOfficerFormRow): boolean {
  return Boolean(
    row.firstName.trim() &&
    row.lastName.trim() &&
    row.title.trim() &&
    row.email.trim() &&
    row.supervisorTitle.trim() &&
    row.supervisorName.trim() &&
      row.supervisorEmail.trim());
}
